import { Identity } from "@sdbn/common";

export class TransportStationAssignment {
    transport: Identity;
    station: Identity;
  }
